import { useState } from 'react';
import { AnalyzerReportsProvider } from '@Context/AnalyzerReportsContext';
import { Sidebar } from '@Components/analyzer-reports/Sidebar';
import { ReportList } from '@Components/analyzer-reports/ReportList';
import { useAuth } from '@Context/CognitoAuthProvider';
import NewUserSettings from '@New/NewUserSettings';

export default function AnalyzerReportsPage() {
  const { user } = useAuth();
  const [expandedWeek, setExpandedWeek] = useState<string[]>([]);

  if (user?.profile?.aha_api_key === '') {
    return <NewUserSettings missing={['aha_api_key']} ahaOnly={true} />;
  }

  return (
    <AnalyzerReportsProvider>
      <div className="flex h-screen w-full flex-row gap-2 overflow-hidden p-6">
        <Sidebar />
        <ReportList
          expandedWeek={expandedWeek}
          setExpandedWeek={setExpandedWeek}
        />
      </div>
    </AnalyzerReportsProvider>
  );
}
